import { Builder } from '@builder.io/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../store/user';
import ReactSelect from 'react-select';
import SelectCurrency from '../../../../general/selectCurrency';
import useHandleAddProduct from '../../../../../utils/handleAddProduct';
import { selectProducts } from '../../../../../store/products';
import ShowCurrencies from '../../../../../utils/showCurrencies';
import useCart from '../../../../../hooks/cart/useCart';
import { openSheet } from '../../../../../store/sheetToggler';
import getSymbolFromCurrency from 'currency-symbol-map';
import { ProductBoxMini } from '../../../../../pages/home/components/productBoxMini';
import googlePayLogo from '../../../../../images/general/gpay-icon.svg';
import applePayLogo from '../../../../../images/general/apple-pay.svg';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import staticImages from '../../../../../constants/staticImages';
import { useTranslation } from 'react-i18next';



const styles = {
  menuList: (base) => ({
    ...base,
    '::-webkit-scrollbar': {
      width: '6px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  }),
};

const GazaWidgetV2 = (props) => {
  /* ----------------------------- Start variables ---------------------------- */
  const {
    addToCart = true,
    suggestedPrices = '70,160,320',
    suggestedPricesMode = 'global',
    suggestedPricesByCurrency = [],
    productsConfig = [],
    mode = 'one-off',
    defaultPrice,
    defaultPriceByCurrency = [],
    isCurrencySpecific = false,
    isSquared = true,
    hideFlag = true,
    description = '',
    title = '',
    hideTitle = true,
    hideDescription = false,
    setRecurring = false,
    banners = [],
    showCurrency = true,
    totalBundlesToBeAchieved,
    showTotalDonation = true,
    deliveredDescription = "bundles delivered. Help us reach",
    generalProductsPricing, 
    showCounter = true,
    showCustomCounter=false,
    customDeliveredDescription = '30000 bundles delivered. Help us reach 4000',
    showPaymentMethods= false,
    showPaymentLogos= false,
    pricingFilter = false,
    showSingle = true,
    showWeekly = true,
    showMonthly = true,
  } = props;
  const [allProducts, setAllProducts] = useState([]);
  const [addProduct] = useHandleAddProduct();
  const products = useSelector((state) => selectProducts(state));
  const [productsList, setProductsList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    creator: productsConfig?.[0]?.creator,
  });
  const [currentProduct, setCurrentProduct] = useState({
    creator: productsConfig?.[0]?.creator,
  });

      const { i18n } = useTranslation();
   const currentLanguage = i18n.language;

  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [currentCurrency, setCurrentCurrency] = useState();
  const [priceOptions, setPriceOptions] = useState([70, 160, 320]);
  const [selectedPrice, setSelectedPrice] = useState(defaultPrice || 1);
  const [productAmount, setProductAmount] = useState(defaultPrice);
  const [productQty, setProductQty] = useState(1);
  const [finalDescription, setFinalDescription] = useState(description || '');
  const [finalTitle, setFinalTitle] = useState(title || '');
  const [isInputChanged, setIsInputChanged] = useState(false);
  const [isGeneralProduct, setIsGeneralProduct] = useState(true);
  const [hasValidatedProduct, setHasValidatedProduct] = useState(false);
  const [defaultPriceGeneral, setDefaultPriceGeneral] = useState(1);
  const [currentSection, setCurrentSection] = useState('');

  const dispatch = useDispatch();
  const { handleAddToGiving: handleAddToGivingCart, handleCheckProduct, handleRemoveProduct} = useCart();

  // Move displayBanner useMemo after currentSection is defined
  const displayBanner = useMemo(() => {
    // Safety check - ensure currentSection is defined
    if (!currentSection || !Array.isArray(banners)) {
      // Fallback to language-specific banner only
      const safeBanners = Array.isArray(banners) ? banners : [];
      const langBanner = safeBanners.find(b => 
        b?.locale && typeof b.locale === 'string' && 
        b.locale.toLowerCase() === currentLanguage.toLowerCase()
      );
      return langBanner?.image ? langBanner : null;
    }

    // First try to find category-specific banner
    const categoryBanner = banners.find(b => 
      b?.category && typeof b.category === 'string' && 
      b.category.toLowerCase() === currentSection.toLowerCase()
    );
    if (categoryBanner?.image) {
      return categoryBanner;
    }
    
    // Fallback to language-specific banner
    const safeBanners = Array.isArray(banners) ? banners : [];
    const langBanner = safeBanners.find(b => 
      b?.locale && typeof b.locale === 'string' && 
      b.locale.toLowerCase() === currentLanguage.toLowerCase()
    );
    
    return langBanner?.image ? langBanner : null;
  }, [currentLanguage, banners, currentSection]);

  const handleSelectedProduct = (value) => {
    const matched = allProducts.find((item) => item.id === value.value);

    if (matched) {
      const isValid =
        matched.usd === 1 &&
        matched.gbp === 1 &&
        matched.eur === 1 &&
        matched.aud === 1 &&
        matched.cad === 1;

      setIsGeneralProduct(isValid);

      setSelectedProduct(matched);
             // Apply CMS overrides for selected product
       const selectedOverride = cmsOverridesMap.get(matched.creator?.trim());
       const finalDescriptionText = selectedOverride?.description || description || matched.description || '';
       const finalTitleText = title || matched.name || '';
       
       setFinalDescription(finalDescriptionText);
       setFinalTitle(finalTitleText);

      // Update localStorage with selected product's section (page-specific)
      const selectedProductConfig = productsConfig.find(p => p.creator?.trim() === matched.creator?.trim());
      const storageKey = `SECTIONS_TOGGLE_${window.location.pathname}`;
      console.log('Selected product:', matched.creator, 'Config:', selectedProductConfig, 'All configs:', productsConfig);
      if (selectedProductConfig?.section) {
        localStorage.setItem(storageKey, selectedProductConfig.section);
        setCurrentSection(selectedProductConfig.section);
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
        console.log('Updated', storageKey, 'to:', selectedProductConfig.section);
      } else {
        console.log('No section found for product:', matched.creator);
        // Set a default section if none found
        localStorage.setItem(storageKey, 'general');
        setCurrentSection('general');
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
      }
    }

    // Set defaultPriceGeneral from generalProductsPricing if creator matches
    if (Array.isArray(generalProductsPricing)) {
      const found = generalProductsPricing.find(
        (entry) => entry.creator === value.creator
      );
      if (found) {
        setDefaultPriceGeneral(found.price);
      } else {
        setDefaultPriceGeneral(1);
      }
    } else {
      setDefaultPriceGeneral(1);
    }

    setCurrentProduct(value);
  };

  // Added for recurring modes
  const suggestedRecurringModes = [
    { value: 'one-off', label: 'Single', show: showSingle },
    { value: 'week', label: 'Weekly', show: showWeekly },
    { value: 'month', label: 'Monthly', show: showMonthly },
  ];
  
  const filteredRecurringModes = suggestedRecurringModes.filter(mode => mode.show);
  
  const [selectedRecurring, setSelectedRecurring] = useState(() => {
    const defaultMode = suggestedRecurringModes.find((item) => item.value === mode && item.show);
    if (defaultMode) {
      return defaultMode;
    }
    // Fallback to first available mode
    return filteredRecurringModes[0] || suggestedRecurringModes[0];
  });

  /* ------------------------------ Start methods ----------------------------- */
  const handleAddNewProduct = () => {
    let tempProduct = {...selectedProduct};
    let quantity = 1;
  
    if (isGeneralProduct) {
      // General products (donations)
      quantity = Number(productAmount) || 1;
    } else {
      // Non-general products (bundles)
      quantity = productQty;
    }
  
    tempProduct = {
      ...tempProduct,
      quantity: quantity,
      recurring: selectedRecurring.value
    };
  
    if (addToCart) {
      handleAddToGivingCart(tempProduct, 'custom');
      dispatch(openSheet());
    } else {
      addProduct({ product: tempProduct, currency: currentCurrency });
    }
  };

  const handleAmountKeyDown = (e) => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleAmountChange = (e) => {
    const regex = /^$|^[1-9][0-9]*$/;
    if (regex.test(e.target.value)) {
      setProductAmount(e.target.value);
      setSelectedPrice(null);
      setIsInputChanged(true);
    }
  };

  const [supportedMethod, setSupportedMethod] = useState('Card');

  const checkIsIOS = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    const isIPadPro = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const isAppleDevice = 
      /iphone|ipad|ipod/.test(userAgent) || 
      (isIPadPro && /macintosh/.test(userAgent));
    const isSafari = 
      userAgent.includes('safari') && 
      !userAgent.includes('chrome') && 
      !userAgent.includes('crios') && 
      !userAgent.includes('fxios');
 
     if (isAppleDevice && isSafari) {
      setSupportedMethod('Apple Pay');
    } else if (!isAppleDevice) {
      setSupportedMethod('Google Pay');
    } else {
      // iOS Chrome or Firefox or unsupported Apple browsers
      setSupportedMethod(null);
    }
  };
 
  useEffect(() => {
    checkIsIOS();
  }, []);

  // Listen for localStorage changes to update banner (page-specific)
  useEffect(() => {
    const handleStorageChange = () => {
      const storageKey = `SECTIONS_TOGGLE_${window.location.pathname}`;
      const section = localStorage.getItem(storageKey) || '';
      setCurrentSection(section);
    };

    // Get initial value
    handleStorageChange();

    // Listen for custom events
    window.addEventListener('localStorageChange', handleStorageChange);

    return () => {
      window.removeEventListener('localStorageChange', handleStorageChange);
    };
  }, []);

  /* ------------------------------- Start hooks ------------------------------ */

  const dropDownList = useMemo(() => {
    return Array.isArray(productsConfig)
      ? productsConfig.map((p) => p?.creator?.trim()).filter(Boolean)
      : [];
  }, [productsConfig]);

  const cmsOverridesMap = useMemo(() => {
    const map = new Map();
    if (Array.isArray(productsConfig)) {
      productsConfig.forEach((item) => {
        if (item?.creator) {
          map.set(item.creator.trim(), {
            description: item.description,
          });
        }
      });
    }
    return map;
  }, [productsConfig]);

  const getAllProducts = (products) => {
    if (!products) return;

    let tempProductsDetailsList = [];
    let tempProductsList = [];

    let defaultProductObj = null;

    // Find matches in store and apply overrides
    products.forEach((item) => {
      item.sub_categories.forEach((inner_item) => {
        inner_item.products.forEach((inner_item_product) => {
          if (Number(inner_item_product.status) === 1) {
            const creatorCode = inner_item_product.creator;
            if (creatorCode === productsConfig?.[0]?.creator?.trim()) {
              defaultProductObj = inner_item_product;
            }
                         if (dropDownList.includes(creatorCode)) {
               const override = cmsOverridesMap.get(creatorCode);
               const resolved = {
                 ...inner_item_product,
                 ...(override?.description ? { description: override.description } : {}),
               };
               tempProductsDetailsList.push(resolved);
               tempProductsList.push({
                 value: inner_item_product.id,
                 label: inner_item_product.name,
                 creator: creatorCode,
               });
             }
          }
        });
      });
    });

    // If some CMS products not found in store, create general fallback entries
    dropDownList.forEach((creatorCode) => {
      const already = tempProductsDetailsList.find((p) => p.creator === creatorCode);
      if (!already) {
        const override = cmsOverridesMap.get(creatorCode) || {};
        const fallbackId = Math.floor(Math.random() * 1e9);
        const fallbackProduct = {
          id: fallbackId,
          creator: creatorCode,
          name: creatorCode,
          description: override.description || '',
          usd: 1, gbp: 1, eur: 1, aud: 1, cad: 1,
          status: 1,
        };
        tempProductsDetailsList.push(fallbackProduct);
        tempProductsList.push({
          value: fallbackId,
          label: creatorCode,
          creator: creatorCode,
        });
      }
    });

    // Set selection
    if (defaultProductObj) {
      setIsGeneralProduct(
        defaultProductObj.usd === 1 &&
        defaultProductObj.gbp === 1 &&
        defaultProductObj.eur === 1 &&
        defaultProductObj.aud === 1 &&
        defaultProductObj.cad === 1
      );

             // Apply CMS overrides for default product
       const defaultOverride = cmsOverridesMap.get(defaultProductObj.creator?.trim());
       const finalDescriptionText = defaultOverride?.description || description || defaultProductObj.description || '';
       const finalTitleText = title || defaultProductObj.name || '';
       
       setFinalDescription(finalDescriptionText);
       setFinalTitle(finalTitleText);
      setSelectedProduct(defaultProductObj);
      const matchedOption = tempProductsList.find(
        (p) => p.value === defaultProductObj.id,
      );
      if (matchedOption) {
        setCurrentProduct(matchedOption);
      }
      
      // Update localStorage with default product's section (page-specific)
      const defaultProductConfig = productsConfig.find(p => p.creator?.trim() === defaultProductObj.creator?.trim());
      const storageKey = `SECTIONS_TOGGLE_${window.location.pathname}`;
      console.log('Default product:', defaultProductObj.creator, 'Config:', defaultProductConfig);
      if (defaultProductConfig?.section) {
        localStorage.setItem(storageKey, defaultProductConfig.section);
        setCurrentSection(defaultProductConfig.section);
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
        console.log('Initial', storageKey, 'set to:', defaultProductConfig.section);
      } else {
        localStorage.setItem(storageKey, 'general');
        setCurrentSection('general');
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
      }
    } else if (tempProductsDetailsList.length > 0) {
      const firstCreator = productsConfig?.[0]?.creator?.trim();
      const firstOption = tempProductsList.find((p) => p.creator === firstCreator) || tempProductsList[0];
      const firstProduct = tempProductsDetailsList.find((p) => p.creator === firstOption?.creator) || tempProductsDetailsList[0];
      setIsGeneralProduct(
        firstProduct.usd === 1 &&
        firstProduct.gbp === 1 &&
        firstProduct.eur === 1 &&
        firstProduct.aud === 1 &&
        firstProduct.cad === 1
      );
             // Apply CMS overrides for first product
       const firstOverride = cmsOverridesMap.get(firstProduct.creator?.trim());
       const finalDescriptionText = firstOverride?.description || description || firstProduct.description || '';
       const finalTitleText = title || firstProduct.name || '';
       
       setFinalDescription(finalDescriptionText);
       setFinalTitle(finalTitleText);
      setSelectedProduct(firstProduct);
      setCurrentProduct(firstOption);
      
      // Update localStorage with first product's section (page-specific)
      const firstProductConfig = productsConfig.find(p => p.creator?.trim() === firstProduct.creator?.trim());
      const storageKey = `SECTIONS_TOGGLE_${window.location.pathname}`;
      console.log('First product:', firstProduct.creator, 'Config:', firstProductConfig);
      if (firstProductConfig?.section) {
        localStorage.setItem(storageKey, firstProductConfig.section);
        setCurrentSection(firstProductConfig.section);
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
        console.log('Initial', storageKey, 'set to:', firstProductConfig.section);
      } else {
        localStorage.setItem(storageKey, 'general');
        setCurrentSection('general');
        // Dispatch custom event to notify components of localStorage change
        window.dispatchEvent(new Event('localStorageChange'));
      }
    } else {
      // Fallback to first product in config
      const fallbackOption = {
        value: defaultProductObj.id,
        label: defaultProductObj.name,
        creator: productsConfig?.[0]?.creator?.trim(),
      };
      setCurrentProduct(fallbackOption);
    }

    tempProductsList.sort((a, b) => {
      return dropDownList.indexOf(a.creator) - dropDownList.indexOf(b.creator);
    });

    setProductsList(tempProductsList);
    setAllProducts(tempProductsDetailsList);
    setIsLoaded(true);
    setHasValidatedProduct(true);
  };

  useEffect(() => {
    products && Object.keys(products).length && getAllProducts(products);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, productsConfig]);
  useEffect(() => {
    selectedCurrencyStore
      ? setCurrentCurrency(selectedCurrencyStore)
      : setCurrentCurrency('AUD');
  }, [selectedCurrencyStore]);

  // 1. Parse logic memoized
const parsedPriceOptions = useMemo(() => {
  const parsePrices = (priceString) => {
    try {
      return priceString
        .split(',')
        .map((price) => parseInt(price.trim(), 10))
        .filter((price) => !isNaN(price) && price > 0);
    } catch {
      return [70, 160, 320];
    }
  };

  if (suggestedPricesMode === 'global') {
    return parsePrices(suggestedPrices);
  } else if (suggestedPricesMode === 'currency-specific') {
    const currencyPrices = suggestedPricesByCurrency.find(
      (item) => item?.currency?.toUpperCase() === currentCurrency?.toUpperCase()
    );
    return currencyPrices?.prices
      ? parsePrices(currencyPrices.prices)
      : parsePrices(suggestedPrices);
  } else if (suggestedPricesMode === 'dynamic-conversion') {
    const basePrices = parsePrices(suggestedPrices);
    if (currentCurrency && selectedProduct) {
      return basePrices.map(basePrice => {
        const convertedPrice = Math.round(
          basePrice * (selectedProduct[currentCurrency.toLowerCase()] / selectedProduct.aud)
        );
        return convertedPrice > 0 ? convertedPrice : basePrice;
      });
    }
    return basePrices;
  }

  return [70, 160, 320];
}, [
  suggestedPrices,
  suggestedPricesMode,
  suggestedPricesByCurrency,
  currentCurrency,
  selectedProduct,
]);


// 2. Apply once
useEffect(() => {
  if (parsedPriceOptions.length > 0) {
    setPriceOptions((prev) => {
      const same = prev.length === parsedPriceOptions.length &&
                   prev.every((val, i) => val === parsedPriceOptions[i]);
      return same ? prev : parsedPriceOptions;
    });

    setSelectedPrice((prev) => {
      return parsedPriceOptions.includes(prev) ? prev : parsedPriceOptions[0];
    });
  }
}, [parsedPriceOptions]);

  useEffect(() => {
    if (Array.isArray(generalProductsPricing) && productsConfig?.[0]?.creator) {
      const creatorKey = productsConfig[0].creator.trim();
      const found = generalProductsPricing.find(
        (entry) => entry.creator === creatorKey
      );
      if (found) {
        setDefaultPriceGeneral(found.price);
      } else {
        setDefaultPriceGeneral(1);
      }
    }
  }, [generalProductsPricing, productsConfig]);

  // Handle currency-specific default price
  useEffect(() => {
    let newDefaultPrice = defaultPrice || 70; // Fallback to global default

    // Only use currency-specific prices if the toggle is enabled
    if (isCurrencySpecific && defaultPriceByCurrency && Array.isArray(defaultPriceByCurrency) && currentCurrency) {
      const currencyDefault = defaultPriceByCurrency.find(
        (item) => item?.currency?.toUpperCase() === currentCurrency?.toUpperCase()
      );
      if (currencyDefault?.price) {
        newDefaultPrice = currencyDefault.price;
      }
    }

    // Update product amount if user hasn't manually changed it
    if (!isInputChanged) {
      setProductAmount(newDefaultPrice);
      setSelectedPrice(newDefaultPrice);
    }
  }, [currentCurrency, isInputChanged, isCurrencySpecific]);

  const paymentMethodsHandler = (showPaymentMethods,supportedMethod) => {
   return showPaymentMethods && (
          <div className="w-full">
            {supportedMethod === 'Apple Pay' ? (
              <button
                onClick={() => {
                  handleAddNewProduct();
                }}
                className='w-full'
              >
                <span className="flex items-center gap-6">
                  <span className="gap-1 h-[56px] flex-1 flex items-center justify-center py-3 px-4 bg-slate-900 hover:bg-slate-800 text-white transition-colors duration-200 font-medium">
                    <img
                      src={applePayLogo}
                      alt="Apple Pay"
                      className="h-6 w-auto"
                    />
                    <span className="font-montserratMedium pt-1">
                      Pay
                    </span>
                  </span>
                </span>
              </button>
            ) : supportedMethod === 'Google Pay' ? (
              <button
                onClick={() => {
                  handleAddNewProduct();
                }}
                className='w-full'
              >
                <span className="flex items-center gap-6">
                  <span className="gap-1 h-[56px] flex-1 flex items-center justify-center py-3 px-4 bg-slate-900 hover:bg-slate-800 text-white transition-colors duration-200 font-medium">
                    <img
                      src={googlePayLogo}
                      alt="Google Pay"
                      className="h-6 w-auto"
                    />
                    <span className="font-montserratMedium pt-1">
                      Pay
                    </span>
                  </span>
                </span>
              </button>
            ) : (
              ''
            )}
          </div>
        )
  };

  return (
    <div className="flex flex-col gap-4 w-full">
        {displayBanner && displayBanner.image && (
            <img src={displayBanner.image} alt={displayBanner.alt || ''} />
        )}
      {/* Recurring modes (Monthly / Single) */}
      {setRecurring && filteredRecurringModes.length > 0 && (
        <div className="flex gap-2 w-full justify-center">
          {filteredRecurringModes.map((modeOption, index) => (
            <button
              key={index}
              className={`flex-1 text-center h-12 font-bold text-xl transition-all duration-200 border border-[#cccac5] ${
                selectedRecurring.value === modeOption.value ? 'bg-[#F60362] !text-white' : 'bg-white text-[#F60362]'
              } ${isSquared ? '' : 'rounded-md'}`}
              onClick={() => setSelectedRecurring(modeOption)}
            >
              {modeOption.label}
            </button>
          ))}
        </div>
      )}
      {/* Product Select */}
      <ReactSelect
        options={productsList}
        className={`max-h-[48px] w-full border gaza_select_campaign sm:min-w-[260px] uppercase ${isSquared ? '[&>div]:!rounded-none' : 'rounded-lg'}`}
        value={currentProduct}
        defaultValue={selectedProduct}
        isSearchable={false}
        styles={styles}
        placeholder="Select Product"
        onChange={(e) => handleSelectedProduct(e)}
        classNamePrefix="orphan_select"
      />

      {/* Description Box */}
      {finalDescription && !hideDescription && (
        <div className="my-4 text-center flex flex-col gap-2 font-montserrat">
          {finalTitle && !hideTitle && (
            <p className="text-[#00a3da] font-bold text-xl uppercase">{finalTitle}</p>
          )}
          <p className="text-[#78716C] text-base md:text-lg font-medium text-left sm:text-center">{finalDescription}</p>
         <div className="flex flex-col gap-1">
          <p className="text-[#14a2dc] text-lg font-montserratBold">
              {!isGeneralProduct && ShowCurrencies(
                  currentCurrency,
                  selectedProduct[currentCurrency.toLowerCase()] * (selectedProduct.quantity || 1),
                  showCurrency
                )}
            </p>
            {!isGeneralProduct && showTotalDonation && (
              <p className="text-[#F60362] text-lg font-montserrat flex items-center justify-center flex-wrap text-center gap-1">
                Your total donation is <span className="font-medium">
                {ShowCurrencies(
                  currentCurrency,
                  (selectedProduct[currentCurrency.toLowerCase()] * productQty),
                  showCurrency
                )}
                </span>
              </p>
            )}
         </div>
        </div>
      )
        }

        {!hasValidatedProduct ? (
            <div className="h-40 flex items-center justify-center">
                <div className="spinner" />
            </div>

        )
      : isGeneralProduct ? (
        <>
            {/* Suggested Prices */}
      <div className="w-full flex flex-wrap gap-2">
        {priceOptions.map((price, index) => {
          return (
            <div key={`prices${index}`} className="flex-1">
              <div
                className={`h-12 w-full transition-all duration-200 cursor-pointer flex justify-center items-center ${!isSquared && 'rounded-md'} py-2 md:py-4 px-1 md:px-2 md:text-lg lg:hover:bg-[#F60362] lg:hover:text-white border border-[#cccac5] ${
                  selectedPrice === price && !isInputChanged
                    ? 'bg-[#F60362]' : 'bg-white'
                } ${selectedPrice === price && !isInputChanged ? '!text-white' : 'text-[#F60362]'}`}
                onClick={() => {
                  setSelectedPrice(price);
                  setProductAmount(price);
                }}
              >
                {ShowCurrencies(currentCurrency, price, true)}
              </div>
            </div>
          );
        })}
      </div>

      {/* Custom Amount Input and Currency Select */}
      <div className={`flex gap-2 w-full border border-[#f60362] bg-white ${!isSquared && 'rounded-lg'}`}>
        <input
          value={isInputChanged ? productAmount : ''}
          className={`w-full p-2 text-lg outline-none focus:ring-1 ring-transparent border-transparent min-w-[156px] ${!isSquared && 'rounded-lg'} border border-[#cccac6] placeholder:text-[#F60362] text-[#F60362]`}
          placeholder={`Any Amount: ${productAmount && getSymbolFromCurrency(currentCurrency)}${productAmount}`}
          type="number"
          min="0"
          onKeyDown={handleAmountKeyDown}
          onChange={handleAmountChange}
        />
        <div className={`min-w-[100px] ${!hideFlag && 'min-w-[140px]'}`} dir="ltr">
          <SelectCurrency
            onChangeCurrency={(e) => setCurrentCurrency(e.value)}
            classNamePrefix="orphan_select"
            hideFlag={hideFlag}
            className={`${isSquared && '[&>div]:!rounded-none'}`}
          />
        </div>
      </div>

      {/* Donate Now Button */}
      <button
        className={`text-white w-full text-sm md:text-lg transition-all duration-200 flex items-center justify-center h-12 px-5 ${!isSquared && 'rounded-md'} ${
          isLoaded ? 'bg-[#f60362]' : 'bg-stone-300 cursor-not-allowed'
        }`}
        onClick={handleAddNewProduct}
      >
        DONATE NOW
      </button>
      </>
      ) : 
      <ProductBoxMini
        key={`product-${selectedProduct.creator}`}
        product={selectedProduct}
        onCheck={handleCheckProduct}
        onAdd={handleAddToGivingCart}
        onRemove={handleRemoveProduct}
        currency={selectedCurrencyStore}
        stateVariableObj={{ productName: selectedProduct.name }}
        _lang={'eng'}
        linkBtnClasses={selectedProduct.linkBtnClasses || ''}
        isStaticProduct={['Zakat Calculator'].includes(selectedProduct.product_type)}
        staticLink={selectedProduct.product_type ? selectedProduct.short_description : ''}
        staticLinkText={selectedProduct.product_type ? selectedProduct.name : ''}
        isSquared={isSquared}
        recurring={selectedRecurring.value}
        totalBundlesToBeAchieved={totalBundlesToBeAchieved}
        setProductQty={setProductQty}
        defaultPriceGeneral={defaultPriceGeneral}
        deliveredDescription={deliveredDescription}
        showCounter={showCounter}
        showCustomCounter={showCustomCounter}
        customDeliveredDescription={customDeliveredDescription}
        setCurrentCurrency={setCurrentCurrency}
        hideFlag={hideFlag}
        productQty={productQty}
        pricingFilter={pricingFilter}
      />
      
      }
      {paymentMethodsHandler(showPaymentMethods,supportedMethod)}
      {showPaymentLogos && (
        <div className={`w-full bg-[#80CEFF] !h-[60px] flex justify-center items-center`}>
          <img {...staticImages.supportingPaymentBig} />
        </div>
      )}
    </div>
  );
};

Builder.registerComponent(GazaWidgetV2, {
  name: 'GazaWidgetV2',
  inputs: [
        {
      name: 'banners',
      type: 'list',
      friendlyName: 'Banners',
      helperText: 'Add banners for specific categories or languages. Category takes priority over language.',
      itemType: 'object',
      subFields: [
        {
          name: 'image',
          type: 'file',
          allowedFileTypes: ['png', 'jpg', 'jpeg', 'webp'],
          required: true,
          helperText: 'Upload banner image',
        },
        {
          name: 'alt',
          type: 'string',
          helperText: 'Alt text for banner image',
        },
        {
          name: 'category',
          type: 'string',
          helperText: 'Category (e.g., water, gaza, lebanon) - Leave empty for language-only banners',
        },
        {
          name: 'locale',
          type: 'string',
          helperText: 'Language code (e.g. de, fr, es) - Leave empty for category-only banners',
        },
      ],
    },
    
    {
      name: 'productsConfig',
      type: 'list',
      friendlyName: 'Products',
      helperText: 'Add products by creator codes. First product becomes the default selection.',
      subFields: [
        { name: 'creator', type: 'string', friendlyName: 'Creator Code', required: true },
        { name: 'description', type: 'string', friendlyName: 'Description Override (optional)' },
        { name: 'section', type: 'string', friendlyName: 'Please add a section to be toggled on product selection' },
      ],
    },
    {
      name: 'defaultPrice',
      type: 'number',
      defaultValue: 70,
      friendlyName: 'Default Donation Amount',
    },
    {
      name: 'isCurrencySpecific',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Enable Currency-Specific Default Prices',
      helperText: 'Toggle to enable currency-specific default prices. If disabled, uses global defaultPrice.',
    },
    {
      name: 'defaultPriceByCurrency',
      type: 'list',
      friendlyName: 'Currency-Specific Default Prices',
      helperText: 'Define different default prices for each currency (only used if Currency-Specific is enabled)',
      subFields: [
        {
          name: 'currency',
          type: 'string',
          friendlyName: 'Currency Code',
          helperText: 'Currency code (e.g., AUD, USD, GBP)',
        },
        {
          name: 'price',
          type: 'number',
          friendlyName: 'Default Price',
          helperText: 'Default price for this currency',
        },
      ],
    },
    {
      name: 'suggestedPrices',
      type: 'string',
      helperText:
        'Comma-separated list of suggested prices (e.g., "100,150,200,500") - Same for all currencies',
    },
    {
      name: 'suggestedPricesMode',
      type: 'enum',
      friendlyName: 'Suggested Prices Mode',
      helperText: 'Choose how suggested prices should be handled',
      enum: ['global', 'currency-specific', 'dynamic-conversion'],
      enumLabels: ['Global (Same for all)', 'Currency Specific', 'Dynamic Conversion'],
      defaultValue: 'global',
    },
    {
      name: 'suggestedPricesByCurrency',
      type: 'list',
      friendlyName: 'Currency-Specific Suggested Prices',
      helperText: 'Define different suggested prices for each currency',
      subFields: [
        {
          name: 'currency',
          type: 'string',
          friendlyName: 'Currency Code',
          helperText: 'Currency code (e.g., AUD, USD, GBP)',
        },
        {
          name: 'prices',
          type: 'string',
          friendlyName: 'Prices',
          helperText: 'Comma-separated prices for this currency (e.g., "20,30,50")',
        },
      ],
    },
    {
      name: 'description',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Description',
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Title',
    },
    {
      name: 'totalBundlesToBeAchieved',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Total Bundles To Achieve',
    },
    {
      name: 'showCounter',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show or Hide delivery counter description',
    },
    {
      name: 'deliveredDescription',
      type: 'string',
      defaultValue: 'bundles delivered. Help us reach',
      friendlyName: 'Delivery Description',
    },
    {
      name: 'showCustomCounter',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show or Hide Custom delivery counter description',
    },
    {
      name: 'customDeliveredDescription',
      type: 'string',
      defaultValue: '30000 bundles delivered. Help us reach 4000',
      friendlyName: 'Custom Delivery Description',
    },
    {
      name: 'containerClassNames',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Main Container Tailwind Classes',
    },
    {
      name: 'hideDescription',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Wheter to Show or Hide Description',
    },
    {
      name: 'hideTitle',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Wheter to Show or Hide Title',
    },
    {
      name: 'addToCart',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Enable Side Cart Add',
    },
    {
      name: 'showPaymentMethods',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Show Payment Methods',
    },
    {
      name: 'showPaymentLogos',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Show Payment Methods Logos',
    },
    {
      name: 'pricingFilter',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Enable Pricing Filter',
    },
    {
      name: 'setRecurring',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Enable Recurring',
    },
    {
      name: 'showSingle',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Single Donation Button',
      helperText: 'Toggle to show/hide the Single donation option',
    },
    {
      name: 'showWeekly',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Weekly Donation Button',
      helperText: 'Toggle to show/hide the Weekly donation option',
    },
    {
      name: 'showMonthly',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Monthly Donation Button',
      helperText: 'Toggle to show/hide the Monthly donation option',
    },
    {
      name: 'isSquared',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Sharp Widget Edges',
    },
    {
      name: 'hideFlag',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Hide Country Flags (Toggle)',
    },
    {
      name: 'showTotalDonation',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Show Total Donation',
    },
    {
      name: 'showCurrency',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Hide Currency Chars in the price after description',
    },
    {
      name: 'mode',
      type: 'enum',
      friendlyName: 'Donation Mode',
      helperText: 'Select how often the donation should recur.',
      enum: ['one-off', 'week', 'month'],
      enumLabels: ['Single', 'Weekly', 'Monthly'],
      defaultValue: 'one-off',
    },
    {
      name: 'generalProductsPricing',
      type: 'list',
      friendlyName: 'General Products Pricing',
      subFields: [
        {
          name: 'creator',
          type: 'string',
          friendlyName: 'Product Creator',
        },
        {
          name: 'price',
          type: 'number',
          friendlyName: 'Default Price',
        },
      ],
      helperText: 'Array of objects: {creator, price} for general product pricing',
    },
  ],
});

export default GazaWidgetV2;
